const breakpoints = {
  hd: '1900px',
  desktop: '1200px',
  tabletpro: '1024px',
  tablet: '992px',
  phone: '414px',
};

export default breakpoints;
